import { useContext } from 'react'
import VehicleContext from '../contexts/VehicleContext'

// Custom hook to use the vehicle context
export const useVehicleContext = () => {
  const context = useContext(VehicleContext)
  if (!context) {
    throw new Error('useVehicleContext must be used within a VehicleProvider')
  }
  return context
}
